import React from 'react';
import DocumentSignModal from './DocumentSignModal';
import { useCurrentDossierCtx } from '../../../providers/CurrentDossierProvider';

const DocumentSignModalWrapper: React.FunctionComponent = function () {
    const { getCurrentDossier, isDataLoaded } = useCurrentDossierCtx();

    if (!isDataLoaded()) {
        return null;
    }

    const dossier = getCurrentDossier();

    if (!dossier) {
        return null;
    }

    const subject = `Signature document(s) dossier "N°${dossier.numero}"  concernant ${dossier.clientOpereLibelle}`;

    return <DocumentSignModal subject={subject} />;
};

export default DocumentSignModalWrapper;
